import React from 'react';
import {
  Mail,
  Calendar,
  Instagram,
  Youtube
} from 'lucide-react';
import '../CSS/Contact.css'
const Contact = () => {
  const contactMethods = [
    {
      icon: Mail,
      title: 'Email',
      description: 'Drop me a line anytime',
      value: 'info@aikanksha.com',
      action: () => window.open('mailto:info@aikanksha.com'),
    },
    {
      icon: Calendar,
      title: 'Schedule Call',
      description: '30-minute consultation',
      value: 'Book a slot',
      action: () => window.open('https://cal.com/akankshaa/30-min-call'),
    },
    {
      icon: Instagram,
      title: 'Instagram',
      description: 'Daily AI insights & tips',
      value: '@aikanksha',
      action: () => window.open('https://instagram.com/aikanksha'),
    },
    {
      icon: Youtube,
      title: 'YouTube',
      description: 'AI tutorials & deep dives',
      value: '@aikanksha',
      action: () => window.open('https://youtube.com/@aikanksha'),
    }
  ];

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <header className="contact-header">
          <h2>
            Let’s <span className="gradient-text">Connect</span>
          </h2>
          <p className="contact-sub">
            Ready to transform your business with AI? I'd love to hear about your project.
          </p>
        </header>

        <div className="methods-grid">
          {contactMethods.map((m, i) => (
            <div key={m.title} className="method-card" onClick={m.action} style={{ animationDelay: `${i * 0.1}s` }}>
              <div className="method-icon"><m.icon size={24} /></div>
              <div className="method-info">
                <h4>{m.title}</h4>
                <p>{m.description}</p>
                <span className="method-value">{m.value}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
